import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import SeatSelect from './SeatSelect';
import { fetchDefault } from '../Utils.js';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
}));

export default function MoveSeat(props) {
    const classes = useStyles();
    let history = useHistory();

    const [seat, setSeat] = React.useState();
    const [seatList, setSeatList] = React.useState([]);
    const [completeOpen, setCompleteOpen] = React.useState(false);

    const onTableChanged = (tableId) => {
        setSeat(tableId);
    };

    const moveSeat = () => {
        fetchDefault('/Seat/MoveSeat?seat=' + seat + '&reservationId=' + props.match.params.reservationId,
            (data) => {
                setCompleteOpen(true);
            }
        );
    };
    

    useEffect(() => {

        //테이블 리스트
        
        fetchDefault('/Seat/GetMoveAvailableSeatList',
            (data) => {
                setSeatList([data][0]);
                /*
                if ([data][0][0].id) {
                    setSeat([data][0][0].id);
                }
                */
            }
        );
        

        return () => {
        }
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>자리 이동하기</h2>
                </Grid>
                
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 자리이동을 원하시는 자리를 선택해주세요.
                    </Typography>

                    <Typography variant="body2">
                        (카페를 둘러보시고, 주변에 있는 자리번호를 확인하세요.)
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <SeatSelect tableList={seatList} seat={seat} onTableChanged={onTableChanged} />
                    {/*<SeatInfoDialog onTableChanged={onTableChanged} time={time} />*/}
                </Grid>

                <Grid item xs={12}>
                    <Button variant="outlined" color="primary" onClick={() => moveSeat()} className={classes.button}>
                        이동하기
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <img alt="loading..." src={require('../../images/seats_v1.0.png')} style={{ width: 650 }} />
                    </Paper>
                </Grid>
            </Grid>

            <Dialog
                open={completeOpen}
                onClose={() => { history.push('/') }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        자리이동이 완료되었습니다!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => { history.push('/'); }}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/seat/MoveSeat.js